import React, {Component} from 'react';
import PropTypes from "prop-types";

import Modal from "./Modal";
import Api from "../api/Api";

import Tags from "@yaireo/tagify/dist/react.tagify"
import "@yaireo/tagify/dist/tagify.css"

class TagOverlay extends Component {
  static propTypes = {
    object: PropTypes.object.isRequired,
    visible: PropTypes.bool,
    onClose: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      indexKey: new Date().getTime()
    };
  }

  onTagSubmit(e) {
    const { object } = this.props;
    e.preventDefault();

    const el = document.querySelector('input[name="tags"]');
    if (!el || !el.value || el.value === "") {
      return;
    }

    if (this.state.loading) {
      return;
    }

    const tags = JSON.parse(el.value).map(tag => tag.value);

    this.setState({
      loading: true
    }, () => {
      Api.post('/tag/suggest?type=' + object.type + "&slug=" + object.slug + "&tags=" + tags.join(",")).then(res => {
        this.setState({
          loading: false,
          indexKey: new Date().getTime()
        })
      });
    });

    return false;
  }

  render() {
    const { object } = this.props;

    return (
      <Modal visible={this.props.visible} onClose={this.props.onClose} header={<h5>Suggest some Tags for {object.title}</h5>}>
        <form onSubmit={this.onTagSubmit.bind(this)}>
          <Tags
            key={this.state.indexKey}
            autoFocus={true}
            loading={this.state.loading}
            value={""}
            name={"tags"}
          />
          <div className={'text-right mt-3'}>
            <button className={'btn btn-primary'}>Save</button>
          </div>
        </form>
      </Modal>
    );
  }
}

export default TagOverlay;